module.exports = __webpack_public_path__ + "static/media/DK-4018.4a7b1872.png";